import { Helmet } from "react-helmet-async";
import { Update514 } from "../../../features/news/articles/update-5-1-4.component";

export const Update514Page = () => {
  return (
    <>
      <Helmet>
        <title>Оновлення True Price 5.1.4: Відновлення функцій, виправлення помилок та стабільність</title>
        <meta name="description" content="Дізнайтеся про останні зміни в True Price 5.1.4: відновлено шильдик знижки, кнопку відстеження, сортування, виправлено помилки меню, додано видалення реклами та полагоджено віджет. Розповідаємо про виклики та рішення." />
        <link rel="canonical" href="https://true-price.top/news/update-5-1-4" />
      </Helmet>
      <Update514 />
    </>);
};